<template>
    <b-overlay :show="tableLoading" rounded="sm">
        <b-card class="p-3">
            
            <b-col class="page-block">
                <strong>
                    {{ $translate("page") }}: {{ pagination.page }}
                    {{ $translate("of") }} {{ pageCount }} {{ $translate("total") }}:
                    {{ pagination.total }}
                </strong>
            </b-col>
            <b-card-header class="assets-filter">
                <b-row class="mt-3">
                    <b-col cols="12" md="12">
                        <div class="d-flex">
                            <b-button variant="blue-button" id="toggle-filter-btn" v-if="hasPermissionView" class="me-2"
                                @click="toggle_filters = !toggle_filters">
                                {{ $translate('filters') }}
                                <b-icon class="ms-1" :icon="'chevron-' +
                                    (toggle_filters ? 'up' : 'down')
                                    " variant="dark"></b-icon>
                            </b-button>
                            <b-button id="reset-filter-btn" variant="blue-button" @click="resetFilters" v-b-tooltip.hover
                                :title="$translate('reset_filters')">
                                <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                            </b-button>
                            <b-button id="export-filter-btn" variant="blue-button" @click="exportData" v-b-tooltip.hover
                            :title="$translate('export_data')" class="mx-2 float-right">
                            Excel
                        </b-button>
                        </div>
                    </b-col>
                    <!-- <b-col cols="12" md="6" class="p-0 pe-md-3 d-flex text-right align-items-center">
                        <slot></slot>
                    </b-col> -->
                </b-row>
                <payment-filters v-show="toggle_filters" v-model="filters" />
            </b-card-header>
            <b-card-body>
                <b-col class="overflow-auto w-100 mt-4">
                    <b-table :fields="fields" responsive :items="items" :per-page="itemsPerPage"
                        :current-page="currentPage" :filter="filters" show-empty>
                        <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #cell(id)="{ item }">
                            <!-- <b-button v-if="hasPermissionView" @click="$emit('show-item', item.id)" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button> -->
                            <b-button :id="'view-payment-btn-'+item.id"  @click="$emit('show-item', item.id)" v-if="allowToUpdatePayment" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                        </template>
                        <template #cell(payment_transaction_status)="{ item }">
                            <h6>
                            <span :title="(item.cancel_reason && item.payment_transaction_status=='cancelled') ? item.cancel_reason: ''" v-b-tooltip.hover>
                            <b-badge :variant="item | filterStatusVariant">
                                {{ (item.payment_transaction_status?.charAt(0).toUpperCase() + item.payment_transaction_status?.slice(1))  }}</b-badge>
                            </span>
                            </h6>
                        </template>
                        <template #empty>
                            <div class="text-center">No Data Available</div>
                        </template>
                    </b-table>
                </b-col>
                <b-row>
                    <b-col>
                        <b-pagination
                            class="justify-content-center mt-4"
                            v-model="pagination.page"
                            :total-rows="pagination.total"
                            :per-page="pagination.pageSize"
                            aria-controls="customerTable"
                            :prev-text="$translate('previous')"
                            :next-text="$translate('next')"
                            pills
                            align="center"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>
<script>
import moment from 'moment'
import popupMixins from '@/mixins/popupMixins'
import addActivityTypeIcon from '@/assets/images/icon/blue-add.svg'
import permissionsMixins from '@/mixins/permissionsMixins'
import PaymentFilters from './PaymentFilters.vue'

const defaultModel = Object.freeze({
    created_start: moment().subtract(30, 'days').format('YYYY-MM-DD'),

    created_end: moment().format('YYYY-MM-DD'),
})

export default {
    name: 'Payments-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: ['type', 'title'],
    components: { PaymentFilters },

    data() {
        return {
            query: "",
            toggle_filters: false,
            filters: {
                order_search: "",
                transactionFromDate: defaultModel.created_start,
                transactionToDate: defaultModel.created_end,
                payment_transaction_status: null,
                payment_transaction_type: null,
                customer_id :null,
                total_amount: null,
                quantityType: 3,
            },
            icon: addActivityTypeIcon,
            itemsPerPage: 15,
            currentPage: 1,
            tableLoading: false,
          
        }
    },
    mounted() {
        const { query } = this.$route;
        if (query.query) this.query = query.query;

        if (query.order_search)
            this.$set(this.filters, "order_search", query.order_search);

        this.doSearch(true)
    },
    filters: {
        filterStatusVariant(item) {
            let badgeClass = '';
            switch (item.payment_transaction_status) {
                case 'pending':
                    badgeClass = 'primary';
                    break;
                case 'processed':
                    badgeClass = 'success';
                    break;
                case 'cancelled':
                    badgeClass = 'danger';
                    break;
            
                default:
                    badgeClass = 'primary';
                    break;
            }
            return badgeClass;
        },
    },
    watch: {
        items: {
            handler: function () {
                // this.tableLoading = false
            },
            deep: true,
        },

        filters: {
            handler: function () {
                console.log('customer is changes!');
                this.doSearch(true)
            },
            deep: true,
        },

        "pagination.page": function () {
            this.doSearch();
        },
    },

    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'external_reference_no', label: this.$translate('external_reference') },
                { key: 'transaction_date', label: this.$translate('transaction_date') },
                {
                    key: 'payment_transaction_type',
                    label: this.$translate('payment_transaction_type'),
                    formatter: (value) => value && (value?.charAt(0).toUpperCase() + value?.slice(1))
                },
                {
                    key: 'payment_type',
                    label: this.$translate('payment_type'),
                    formatter: (value) => value && (value?.charAt(0).toUpperCase() + value?.slice(1))
                },
                {
                    key: 'activity',
                    label: this.$translate('activity_no'),
                    formatter: (value) =>value && (value.reference_no),
                },
                {
                    key: 'customer',
                    label: this.$translate('customer_name'),
                    formatter: (value, key, item) => item.activity?.customer?.name 
                },
                 {
                    key: 'payment_amount',
                    label: this.$translate('payment_amount'),
                    // formatter: (value) =>value && (value.payment_amount),
                },
                {
                    key: 'payment_description',
                    label: this.$translate('description'),
                    thStyle: { whiteSpace: "normal" }
                },
                {
                    key: 'payment_transaction_status',
                    label: this.$translate('payment_transaction_status'),
                },
                {
                    key: 'payment_purpose',
                    label: this.$translate('payment_purpose'),
                    formatter: (value) => value && (value?.charAt(0).toUpperCase() + value?.slice(1))
                },
                {
                    key: 'bank',
                    label: this.$translate('bank_code'),
                    formatter: (value) => value && (value.bank_name?.charAt(0).toUpperCase() + value.bank_name?.slice(1))
                },
            ]
        },
        user() {
            return this.$store.state.user
        },

        rows() {
            return this.items.length
        },
        
        item() {
            // console.log('this is getting computed-', this.$store.state.payments.items)
            const item= this.$store.state.payments.item
           
            return item
        },
        items() {
            // console.log('this is getting computed-', this.$store.state.payments.items)
            const items = this.$store.state.payments.items
            console.log('items', items)
            return items
        },
        attachments() {
            console.log('This is attachments-----', this.$store.state.paymentAttachmentsStore.attachments)
            return this.$store.state.paymentAttachmentsStore.attachments
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize);
        },
        pagination() {
            return this.$store.state.payments.pagination || { page: 1 };
        },
        allowToUpdatePayment() {
            return !!this.user_permissions.includes(
              "update.payments"
             );
        },
    },

    methods: {
        resetFilters() {
            this.filters = {
                order_search: "",
                transactionFromDate: defaultModel.created_start,
                transactionToDate: defaultModel.created_end,
                payment_transaction_status: null,
                payment_transaction_type: null,
            }
            this.doSearch()
        },
        async doSearch(isforcedReload = false) {

            let {
                query,
                pagination: { page },
                filters
            } = this
            
            if(filters.order_search !="" && filters.order_search.length < 3) return;
            
            page = parseInt(page) || 1;
            
            this.tableLoading = true
            try{
                await this.$store.dispatch('payments/fetchAll', {
                    query,
                    filters,
                    page,
                    isforcedReload
                })
            } catch(err) {
                console.log('Payment fetch Error: ', err);
                this.doToast(this.$translate('error'), err.message, 'danger')
            } finally {
                this.tableLoading = false
            }
        },
        async exportData() {
         console.log('callled');
         
            let {
                query,
                filters
            } = this
            
            if(filters.order_search !="" && filters.order_search.length < 3) return;
            
            this.tableLoading = true
            await  this.$store.dispatch('payments/exportExcel', {
                query,
                filters,
            })
            this.tableLoading = false
        }
    },
}
</script>
<style scoped>
.float-right{
    float:right !important;
}
</style>
